export default class DtoMapSituationStat {
    constructor(obj) {
        this.mapId = obj.mapId
        this.classId = obj.classId
        this.nb = obj.nb
        this.threshold = obj.threshold
        this.color = obj.color
        this.mapName = obj.mapName
        this.date = obj.date
    }
}